<template>
  <div class="table-container">
    <md-table v-model="table">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell
          v-for="(cell, title) in item"
          :key="title + Math.random().toString()"
          :md-label="startCase(title)"
          :class="cell && cell.classList"
        >
          <template v-if="cell && cell.type == cellTypes.label">
            <p :class="cell && cell.classList" class="vp-py-20 vp-mx-24">
              {{ cell.value }}
            </p>
          </template>

          <template v-else-if="cell && cell.type == cellTypes.multiselect">
            <vp-multiselect
              :disabled="massActionInit"
              v-model="cell.value"
              :initialValue="cell.value"
              :options="cell.options"
              trackBy="id"
              label="name"
              title="Select .."
              :zIndex="cell.zIndex.toString()"
              :showTitle="false"
              :allowEmpty="true"
              backgroundColor="#fff"
              :showOptionsBorder="true"
              :width="cell.width"
              @open="onMultiselectOpen"
              @close="onMultiselectClose"
              @input="$emit('onMultiselectInput', cell)"
            />
          </template>

          <template v-else-if="cell && cell.type == cellTypes.input">
            {{ cell.value }}
          </template>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { startCase } from "lodash";

export default {
  data() {
    return {
      cellTypes: {
        label: "label",
        multiselect: "multiselect",
        input: "input",
      },
      options: [
        { id: 1, value: "Option 1" },
        { id: 2, value: "Option 2" },
        { id: 3, value: "Option 3" },
        { id: 4, value: "Option 4" },
      ],
    };
  },
  props: {
    table: {
      type: Array,
      default: () => [],
    },
    validations: {},
    massActionInit: {
      type: Boolean,
    },
  },
  methods: {
    startCase(header) {
      return startCase(header);
    },
    onMultiselectOpen() {
      setTimeout(() => {
        const lastMultiselectActive = document.querySelector(
          "tbody>tr:nth-last-child(1) .multiselect--active"
        );
        const lastMultiselectActive_2 = document.querySelector(
          "tbody>tr:nth-last-child(2) .multiselect--active"
        );
        const lastMultiselectActive_3 = document.querySelector(
          "tbody>tr:nth-last-child(3) .multiselect--active"
        );
        const table = document.querySelector(".md-table-content");
        if (lastMultiselectActive) {
          table.classList.add("vp-pb-50");
        } else if (lastMultiselectActive_2) {
          table.classList.add("vp-pb-25");
        } else if (lastMultiselectActive_3) {
          table.classList.add("vp-pb-10");
        }
      }, 1);
    },
    onMultiselectClose() {
      const table = document.querySelector(".md-table-content");
      table.classList.remove("vp-pb-50", "vp-pb-25", "vp-pb-10");
    },
  },
};
</script>

<style lang="scss">
.table-container {
  overflow-y: visible !important;
  tr.md-table-row:hover {
    background: #ffffff !important;
  }
  table thead tr th:first-of-type,
  table tbody td:first-of-type {
    padding-inline-start: 16px !important;
  }
  table {
    overflow: visible !important;
    margin-bottom: 10px;

    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;

    td.md-table-cell {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
    }

    .md-table-head-label {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #939393;
      padding-inline-start: 25px !important;
      display: flex;
      align-items: center;
    }

    .md-table-cell,
    .md-table-head {
      border-inline-end: 1px solid #f2f2f2;
    }

    tbody .md-table-row td {
      border-top: 1px solid #f2f2f2;
    }

    .md-table-cell-container {
      min-width: 200px;
      padding: 0;
    }

    .md-table-cell {
      transition: border 0s !important;
      color: #495057;
    }
  }
}
</style>
